module.exports = __webpack_public_path__ + "static/media/artist_pol-y_w.6f09f6c5.png";